import {
  MultiSelectFilter,
  MultiSelectFilterOption,
} from 'deckard-ui/dist/components/MultiSelectFilter/MultiSelectFilter';
import React, { useCallback } from 'react';
import { ViolationStatus } from '../../../api/rentalscape/__generated_types__/graphql';
import {
  HIDE_VIOLATION_STATUS_LIST,
  VIOLATION_STATUS_TO_USER_STRING_MAP,
} from '../constants';
import { VIOLATIONS_TABLE_TEST_IDS } from '../test-ids';
import { ViolationType } from '../types';

export interface ViolationsFiltersProps {
  /** Currently selected violation types */
  selectedViolationTypes: string[];
  /** Callback when violation types selection changes */
  onViolationTypesChange: (value: string[]) => void;

  /** Violation types for the dropdown */
  violationTypes: MultiSelectFilterOption[];

  /** Currently selected violation statuses */
  selectedViolationStatuses: ViolationStatus[];
  /** Callback when violation statuses selection changes */
  onViolationStatusesChange: (value: ViolationStatus[]) => void;
}

export const ViolationsFilters: React.FC<ViolationsFiltersProps> = ({
  selectedViolationTypes,
  onViolationTypesChange,
  selectedViolationStatuses,
  onViolationStatusesChange,
  violationTypes,
}) => {
  const handleViolationTypeChange = useCallback(
    (selectedKeys: string[]) => {
      const newSelectedTypes = selectedKeys as ViolationType[];
      onViolationTypesChange(newSelectedTypes);
    },
    [onViolationTypesChange]
  );

  const handleViolationStatusChange = useCallback(
    (selectedKeys: string[]) => {
      const newSelectedStatuses = selectedKeys as ViolationStatus[];
      onViolationStatusesChange(newSelectedStatuses);
    },
    [onViolationStatusesChange]
  );

  const violationStatusOptions: MultiSelectFilterOption[] = Object.entries(
    VIOLATION_STATUS_TO_USER_STRING_MAP
  )
    .filter(
      ([key]) => !HIDE_VIOLATION_STATUS_LIST.includes(key as ViolationStatus)
    )
    .map(([key, value]) => ({
      key,
      value,
    }));

  return (
    <div className="mb-4 flex gap-4">
      <MultiSelectFilter
        title="Violation Types"
        options={violationTypes}
        selectedKeys={selectedViolationTypes}
        onSelectionChange={handleViolationTypeChange}
        testId={VIOLATIONS_TABLE_TEST_IDS.VIOLATION_TYPE_DROPDOWN}
      />

      <MultiSelectFilter
        title="Statuses"
        options={violationStatusOptions}
        selectedKeys={selectedViolationStatuses}
        onSelectionChange={handleViolationStatusChange}
        testId={VIOLATIONS_TABLE_TEST_IDS.VIOLATION_STATUS_DROPDOWN}
      />
    </div>
  );
};

export default ViolationsFilters;
